'use client'

import { Page } from '@/payload-types'
import React from 'react'
import { getSeasonText } from '@/utilities/getSeasonText'
import { TypedLocale } from 'payload'
import { WelcomeBlock } from '@/blocks/WelcomeBlock/Component'

function SeasonText({ hero }: { hero: Page['hero'] & { locale: TypedLocale } & { title: string } }) {
    const winter = hero.winter && hero.winter.titleWinter && hero.winter.contentWinter && hero.winter.media && typeof hero.winter.media !== 'string'
    ? { title: hero.winter.titleWinter, content: hero.winter.contentWinter, media: hero.winter.media }
    : null;
  const summer = hero.summer && hero.summer.titleSummer && hero.summer.contentSummer && hero.summer.media && typeof hero.summer.media !== 'string'
    ? { title: hero.summer.titleSummer, content: hero.summer.contentSummer, media: hero.summer.media }
    : null;
    const seasonText = getSeasonText(winter, summer, hero.title, new Date())
    if (!seasonText) return null
  return (
    <div>
       {seasonText && seasonText.title && seasonText.content && (
        <WelcomeBlock
          title={seasonText.title}
          content={seasonText.content}
          blockType="welcomeBlock"
        />
      )}
    </div>
  )
}

export default SeasonText